export const getLoginFormDataFromRootDocument = () => {
  const root = document.getElementById("root");
  const orderId = root.dataset.invoiceNumber;
  const email = root.dataset.email;
  return {
    orderId,
    email,
  };
};

export const removeLoginFormDataFromRootDocument = () => {
  const root = document.getElementById("root");
  delete root.dataset.invoiceNumber;
  delete root.dataset.email;
};
